import type { NotFoundError } from '@tanstack/react-router'

export async function loadRouteDataOrNotFound<T>(
  load: () => Promise<T>,
  createNotFound: () => NotFoundError
): Promise<T> {
  try {
    return await load()
  } catch (error) {
    if (isForbiddenOrMissingResponse(error)) {
      throw createNotFound()
    }

    throw error
  }
}

/** An API answer that the record is gone or isn't this user's to see (403/404), as opposed to a failed request. */
export function isForbiddenOrMissingResponse(error: unknown): boolean {
  if (typeof error !== 'object' || error === null || !('response' in error)) return false

  const { response } = error

  return (
    typeof response === 'object' &&
    response !== null &&
    'status' in response &&
    (response.status === 403 || response.status === 404)
  )
}
